import { createFileRoute } from '@tanstack/react-router'

import { buildPageTitle } from '@/shared/lib/page-title'
import { LibraryListPage } from '@/features/library'

export const Route = createFileRoute('/_authenticated/_main/biblioteca/')({
  head: () => ({
    meta: [{ title: buildPageTitle('Biblioteca') }]
  }),
  component: LibraryListPage
})
